function NXTheme({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4293_1270)">
        <path
          d="M13.9643 16.1073C14.8716 16.1073 15.6071 15.3718 15.6071 14.4644V2.96444C15.6071 2.06963 14.8591 1.32158 13.9643 1.32158H2.46427C1.56946 1.32158 0.821411 2.06963 0.821411 2.96444V14.4644C0.821411 15.3593 1.56946 16.1073 2.46427 16.1073H13.9643Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5357 22.6787C21.443 22.6787 22.1785 21.9432 22.1785 21.0359V9.53587C22.1785 8.64105 21.4305 7.89301 20.5357 7.89301H9.03568C8.14086 7.89301 7.39282 8.64105 7.39282 9.53587V21.0359C7.39282 21.9307 8.14086 22.6787 9.03568 22.6787H20.5357Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4293_1270">
          <rect
            width="23"
            height="23"
            fill="white"
            transform="translate(0 0.500153)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NXTheme;
